window.addEventListener('scroll', handleScroll);
window.addEventListener('load', handleScroll); // Check scroll position on page load

function handleScroll() {
    const menu = document.querySelector('header');
    const hasModalOpen = document.querySelector('.has-modal-open');

    if (window.scrollY > 20) { // Adjust scroll value as needed
        menu.classList.add('scrolled');
        menu.classList.remove('anim');
    } else {
        menu.classList.add('anim');
        menu.classList.remove('scrolled');
    }
}

// Optional: MutationObserver to handle dynamically added/removed 'has-modal-open' class
// MutationObserver for changes on the <html> tag
/*
const observer = new MutationObserver(() => {
  handleScroll(); // Ensure proper behavior when 'has-modal-open' changes on <html>
});

observer.observe(document.documentElement, {
  attributes: true, // Listen for attribute changes
  attributeFilter: ['class'] // Only observe class changes
});
*/
/*================ ANIMATE ============*/
if (navigator.userAgent.indexOf('Safari') != -1 && 
    navigator.userAgent.indexOf('Chrome') == -1) {
        document.body.className += " safari";
    }
document.addEventListener("DOMContentLoaded", function() {

    const fadeIns = document.querySelectorAll('.fade-in,.animation-effect-fade-in');
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
           
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.1 });

    fadeIns.forEach(fadeIn => {
        if (isElementInViewport(fadeIn) || fadeIn.classList.contains('visible')) {
            fadeIn.classList.add('visible');
        } else {
            observer.observe(fadeIn);
        }
    });

    function isElementInViewport(el) {
        const rect = el.getBoundingClientRect();
        return (
          rect.top < window.innerHeight &&
          rect.bottom > 0 &&
          rect.left < window.innerWidth &&
          rect.right > 0
        );
    }
});

/*=== NAVIGATION ===*/

document.querySelectorAll('.wp-block-navigation-submenu').forEach(submenu => {
    submenu.addEventListener('click', function(event) {
      // Get the width and height of the submenu
      const submenuWidth = submenu.offsetWidth;
      const submenuHeight = submenu.offsetHeight;
  
      // Calculate the position for the right 30% of the submenu
      const right30PercentPosition = submenuWidth * 0.7; // 70% of the submenu width, where 30% will be clickable
  
      // Define the top 50px range for click detection
      const top50pxPosition = submenu.getBoundingClientRect().top + 50;
  
      // Check if the click occurred within the right 30% of the submenu and within the top 50px of the height
      if (
        event.clientX > submenu.getBoundingClientRect().left + right30PercentPosition &&
        event.clientY < top50pxPosition
      ) {
        submenu.classList.toggle('active-submenu');  // Toggle the active class
      }
    });
  });


  /*==== TAble Block item =====*/

  document.querySelectorAll('.wp-block-gfd-services-table-item-block').forEach(item => {
    item.addEventListener('click', function() {
      const link = item.querySelector('a'); // Find the first <a> inside the div
      if (link) {
        window.location.href = link.href; // Redirect to the <a>'s href
      }
    });
  });

  /*====== GCLID ========*/

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  }
  
  function getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  function getParam(p){
    var match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
  }

  document.addEventListener('DOMContentLoaded', function() {
    var gclid = getParam('gclid');

    if(gclid){
      var gclsrc = getParam('gclsrc');
      setCookie('wordpress_gclid', gclid, 90);
      if(!gclsrc || gclsrc.indexOf('aw') !== -1){    
      }
    }
    // List of IDs to apply the gclid value
    var gclidFields = document.querySelectorAll('#gform_fields_1 #field_1_12 #input_1_12, #gform_fields_2 #field_2_9 #input_2_9, #gform_fields_4 #field_4_11 #input_4_11');

    gclidFields.forEach(function(field) {
      if (field) {
        field.value = getCookie('wordpress_gclid');
      }
    });
  });

/*====== COUNT DOWN ======*/
function animateCountUpForClass(query, duration = 2000, concat = '') {
  const elements = document.querySelectorAll(query);

  elements.forEach((element) => {
    // Extract numbers and ignore any non-numeric suffix
    const numberString = element.textContent.replace(/[^\d.,]/g, '').replace(/,/g, '');
    const target = parseInt(numberString, 10);

    let start = 0;
    const startTime = Date.now();

    function formatNumber(number) {
      return number.toLocaleString() + concat;
    }

    // Easing function (ease-out quadratic)
    function easeOutQuad(t) {
      return t * (2 - t);
    }

    function updateCount() {
      const elapsedTime = Date.now() - startTime;
      const progress = Math.min(elapsedTime / duration, 1);
      const easedProgress = easeOutQuad(progress);

      start = Math.floor(easedProgress * target);
      element.textContent = formatNumber(start);

      if (progress < 1) {
        requestAnimationFrame(updateCount);
      } else {
        element.textContent = formatNumber(target); // Ensure the final value is exact
      }
    }

    element.textContent = '0' + concat; // Reset to 0 before starting
    updateCount();
  });
}
  
  // Call the function
  animateCountUpForClass('.no-percent .count-up strong', 3000); // Adjust duration as needed (in milliseconds)
  animateCountUpForClass('.percent .count-up strong', 3000, '%'); // Adjust duration as needed (in milliseconds)